<template>
  <div>
    <b-row v-if="loading" class="m-0">
      <b-col class="col-12 p-0 grid">
        <b-skeleton class="box-image-0 skeleton-cell" />
        <b-skeleton class="box-image-1 skeleton-cell" />
        <b-skeleton class="box-image-2 skeleton-cell" />
        <b-skeleton class="box-image-3 skeleton-cell" />
        <b-skeleton class="box-image-4 skeleton-cell" />
      </b-col>
    </b-row>

    <b-row v-else-if="data_header.images && data_header.images.length > 0" class="m-0">
      <b-col :class="`${is_avaible_to_editing && !data_header.is_in_sidebar ? 'col-12 col-lg-8' : 'col-12'} p-0 grid`" :key="update_image">
        <div 
          :class="`${getClassForAmountImages(index, images)} container-image-grid`" 
          v-for="(image, index) in images" 
          :key="index"
          @click="openSwiper(index)"
        > 
          <!-- Normal Image -->
          <b-img 
            v-if="!isVideo(image.media)" 
            :src="image.error_to_load ? image.media : verifyAsset(image.media)"
            square 
            class="avatar-preview-header-steps"
            @error="errorLoad(image.media)"
          ></b-img>
          <!-- Preview Video -->
          <b-img 
            v-else-if="isVideo(image.media) && image.preview.length > 0" 
            :src="image.error_to_load ? image.preview : verifyAsset(image.preview)"
            square 
            class="avatar-preview-header-steps"
            @error="errorLoad(image.media)"
          ></b-img>
          <!-- In case it does not have a preview of video -->
          <video
            v-else
            muted 
            :src="verifyAsset(image.media)"
            class="avatar-preview-header-steps"
          ></video>
          <div class="main-container-icon-hover">
            <div class="icon-hover-grid">
              <div>
                <b-avatar icon="play-fill" class="text-success" variant="light" size="20px" v-if="isVideo(image.media)"></b-avatar>
              </div>
              <b-avatar icon="arrows-fullscreen" class="text-dark" variant="light" size="20px"></b-avatar>
            </div>
          </div>
        </div>
        <b-button class="button-see-more-images" variant="light" @click="open_modal_images = true; update_modal_images += 1" v-if="data_header.images.length > 1">{{ $t('creator.seeAll') }} {{data_header.images.length}} {{ $t('creator.images') }}</b-button>
        <div class="background-button-edit" @click="$emit('edit_proposal', 'samples')" v-if="is_avaible_to_editing && !data_header.is_in_sidebar">
          <h5 class="text-white animation-opacity-words">{{$t('creator.editSamples')}}</h5>
        </div>
      </b-col>
      <b-col class="d-none d-lg-block col-4 p-0 pl-2" v-if="is_avaible_to_editing && !data_header.is_in_sidebar">
        <div :id="`samples-bubble-filled-${_uid}`" class="bubble-edit" @click="$emit('edit_proposal', 'samples')">
          <feather-icon icon="Edit2Icon"></feather-icon>
          <span class="ml-05 avenir-bold">{{$t('creator.samplesStep')}}</span>
          <samples-tip :target="`samples-bubble-filled-${_uid}`" />
        </div>        
      </b-col>
    </b-row>
    
    <!-- Box when samples length === 0 -->
    <b-row class="m-0 w-100 mb-2 pl-0" v-else-if="is_avaible_to_editing && !data_header.uploaded_images">
      <b-col class="col-12 col-md-8 p-0 m-0 h-100">
        <b-button :id="`samples-dropzone-${_uid}`" class="add-option-action" variant="add-option-action" @click="$emit('edit_proposal', 'samples')">
          <h4 class="avenir-bold d-flex align-items-center justify-content-center">
            {{$t('creator.samplesStep')}}
            <samples-tip :target="`samples-dropzone-${_uid}`" />
          </h4>
          <p class="avenir-medium m-0">{{$t('creator.mediaAdd')}}</p>
        </b-button>
      </b-col>
      <b-col class="d-none d-md-block col-4 p-0 pl-2 h-100">
        <div :id="`samples-bubble-empty-${_uid}`" class="bubble-edit red-edit-bubble h-100" @click="$emit('edit_proposal', 'samples')">
          <div>
            <b-icon icon="asterisk"></b-icon>
            <span class="ml-05 avenir-bold">{{$t('creator.samplesStep')}}</span>
            <samples-tip :target="`samples-bubble-empty-${_uid}`" />
            <p class="avenir-medium m-0">{{$t('creator.mediaReq')}}</p>
          </div>
        </div>        
      </b-col>
    </b-row>

    <!-- Placeholder when no images exist and not in editing mode -->
    <b-row v-else class="m-0">
      <b-col class="col-12 p-0 grid grid-placeholder">
        <div class="box-image-0 placeholder-cell">
          <b-icon icon="image" font-scale="2" class="text-secondary"></b-icon>
        </div>
        <div class="box-image-1 placeholder-cell">
          <b-icon icon="image" font-scale="1.5" class="text-secondary"></b-icon>
        </div>
        <div class="box-image-2 placeholder-cell">
          <b-icon icon="image" font-scale="1.5" class="text-secondary"></b-icon>
        </div>
        <div class="box-image-3 placeholder-cell">
          <b-icon icon="image" font-scale="1.5" class="text-secondary"></b-icon>
        </div>
        <div class="box-image-4 placeholder-cell">
          <b-icon icon="image" font-scale="1.5" class="text-secondary"></b-icon>
        </div>
      </b-col>
    </b-row>

    <swiper-brandme 
      v-if="open_modal_images" 
      :open_modal_images="open_modal_images" 
      :key="update_modal_images" 
      :swiper_data="swiper_data"
      :current_slide_index="index_image_swiper"
    ></swiper-brandme>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BAvatar,
  BImg,
  BButton,
  BIcon,
  BSkeleton,
} from 'bootstrap-vue';
import SamplesTip from '@/views/components/proposals/components/SamplesTip.vue';
import swiperBrandme from '@/views/components/swiper-brandme/swiperBrandme.vue';
import { isVideo } from '@/libs/utils/formats';
import { getAssetUrl, isUrl, verifyAsset } from '@/libs/utils/urls';

export default {
  name: 'HeaderImagesPreview',
  components: {
    BRow,
    BCol,
    BAvatar,
    BImg,
    BButton,
    BIcon,
    BSkeleton,
    swiperBrandme,
    SamplesTip,
  },
  props: {
    data_header: {
      type: Object,
      default: () => ({})
    },
    is_avaible_to_editing: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      verifyAsset,
      isUrl,
      getAssetUrl,
      isVideo,
      open_modal_images: false,
      update_modal_images: 0,
      update_image: false,
      images: [],
      index_image_swiper: 0,
      swiper_data: [],
    }
  },
  created() {
    this.getImages();
  },
  watch: {
    loading(val) {
      if (!val) this.getImages();
    }
  },
  methods: {
    errorLoad(image) {
      const image_error = this.data_header.images.find((i) => i.media === image);
      image_error.media = require("@/assets/images/dashboard/imgDefault.png");
      image_error.error_to_load = true;
    },
    openSwiper(index) {
      this.open_modal_images = true;
      this.update_modal_images += 1;
      this.index_image_swiper = index;
    },
    getImages() {
      if (!this.data_header.images) return;
      this.images = this.data_header.images.sort((a, b) => a.sort - b.sort).slice(0, 5);
      const images_swiper = [];
      this.data_header.images.sort((a, b) => a.sort - b.sort).map((item) => {
        isVideo(item.media) ? images_swiper.push(
          {video: !isUrl(item.media) ? getAssetUrl(item.media) : item.media}
        ) : images_swiper.push({img: !isUrl(item.media) ? getAssetUrl(item.media) : item.media})
      });
      this.swiper_data = images_swiper;
    },
    getClassForAmountImages(index, images) {
      if (images.length === 5) {
        return `box-image-${index}`
      } else if (images.length === 1) {
        return `box-image-one`
      } else if (images.length === 2) {
        return `box-image-two-${index}`
      } else if (images.length === 3) {
        return `box-image-three-${index}`
      } else if (images.length === 4) {
        return `box-image-four-${index}`
      } 
    },
  },
}
</script>
<style scoped lang="scss">
.skeleton-cell {
  height: 100%;
  width: 100%;
  border-radius: 0.4em;
  margin: 0 !important;
}
.skeleton-generated-media-samples {
  height: 100%;
  width: 100%;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.3) !important;
}
.container-image-grid {
  background-color: #ebebeb;
  display: flex;
  justify-content: center;
  align-items: center;
}
.container-image-grid:hover {
  cursor: pointer;
  position: relative;
}
.container-image-grid:hover .main-container-icon-hover {
  transition: all 500ms;
  display: block;
}
.main-container-icon-hover {
  display: none;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.35);
}
.icon-hover-grid {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 1em;
  display: flex;
  width: 100%;
  justify-content: space-between;
  transition: all 500ms;
}
.grid {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(2, 190px);
  gap: 10px;
  position: relative;
}

.background-button-edit {
  background-color: transparent;
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  border-radius: 0.55em;
}
.animation-opacity-words {
  opacity: 0;
}
.grid:hover .background-button-edit {
  background-color: #3b8da888;
  transition: all 500ms;
  cursor: pointer;
  backdrop-filter: blur(10px);
}
.grid:hover .animation-opacity-words {
  opacity: 1;
  transition: all 500ms;
}
.grid:not(:hover) .background-button-edit, 
.grid:not(:hover) .animation-opacity-words {
  transition: all 500ms;
}
.bubble-edit {
  text-align: left;
  padding: 1em;
  color: #3b8DA8;
  background: #E6f2f6;
  border-radius: 1em;
  cursor: pointer;
  position: sticky;
  position: -webkit-sticky;
  top: 5em;
}
.bubble-edit:hover {
  transition: all 300ms;
  background: #3b8da82f;
}
.bubble-edit:before {
  border: 10px solid #E6f2f6;
  content: '';
  border-left-color: transparent;
  border-bottom-color: transparent;
  border-right-color: transparent;
  position: absolute;
  transform: rotate(90deg);
  left: -19px;
}
.bubble-edit:hover:before {
  border: 10px solid #3b8da82f;
  content: '';
  border-left-color: transparent;
  border-bottom-color: transparent;
  border-right-color: transparent;
  position: absolute;
  transform: rotate(90deg);
  left: -19px;
  transition: all 300ms;
}
/* red bubble */
.red-edit-bubble {
  color: #2969C8 !important;
  background: #2969c81e !important;
  min-height: 75.5px !important;
}
.red-edit-bubble:before {
  border: 10px solid #2969c81e !important;
  content: '' !important;
  border-left-color: transparent !important;
  border-bottom-color: transparent !important;
  border-right-color: transparent !important;
  position: absolute !important;
  transform: rotate(90deg) !important;
  left: -19px !important;
}
.red-edit-bubble:hover {
  background-color: #2969c83a !important;
}
.red-edit-bubble:hover:before {
  border: 10px solid #2969c83a !important;
  content: '' !important;
  border-left-color: transparent !important;
  border-bottom-color: transparent !important;
  border-right-color: transparent !important;
  position: absolute !important;
  transform: rotate(90deg) !important;
  left: -19px !important;
}
.add-option-action {
  border: 2px dashed #2969C8;
  color: #2969C8;
}
.add-option-action h4 {
  color: #e11717;
}
.box-add-option-absolute {
  background-color: #2969C8;
}
.add-option-action:hover {
  border: 2px solid #2969C8;
}
.ml-05 {
  margin-left: 0.55em;
}
.box-image-0 {
  grid-column: 1 / 3;
  grid-row: 1 / 3;
  @media(max-width: 860px){
    grid-column: 1 / 4;
  }
}
.box-image-1 {
  grid-column: 3 / 4;
  grid-row: 1 / 3;
  @media(max-width: 860px){
    grid-column: 4 / 8;
    grid-row: 1;
    margin-bottom: 5px;
  }
}
.box-image-2 {
  grid-column: 4 / 5;
  grid-row: 1;
  @media(max-width: 860px){
    grid-column: 4/ 8;
    grid-row: 2;
  }
}
.box-image-3 {
  grid-column: 4 / 5;
  grid-row: 2;
  @media(max-width: 860px){
    display: none;
  }
}
.box-image-4 {
  grid-column: 5 / 6;
  grid-row: 1 / 3;

  @media(max-width: 860px){
    display: none;
  }
}
.box-image-one {
  grid-column: 1 / 6;
  grid-row: 1 / 3;
} 
.box-image-two-0 {
  grid-column: 1 / 4;
  grid-row: 1 / 3;
} 
.box-image-two-1 {
  grid-column: 4 / 6;
  grid-row: 1 / 3;
} 
.box-image-three-0 {
  grid-column: 1 / 3;
  grid-row: 1 / 3;
  @media(max-width: 860px){
    grid-column: 1 / 4;
  }
} 
.box-image-three-1 {
  grid-column: 3 / 5;
  grid-row: 1 / 3;
  @media(max-width: 860px){
    grid-column: 4 / 8;
    grid-row: 1;
    margin-bottom: 5px;
  }
} 
.box-image-three-2 {
  grid-column: 5 / 6;
  grid-row: 1 / 3;
  @media(max-width: 860px){
    grid-column: 4/ 8;
    grid-row: 2;
    margin-bottom: 0;
  }
}
.box-image-four-0 {
  grid-column: 1 / 3;
  grid-row: 1 / 3;
  @media(max-width: 860px){
    grid-column: 1 / 4;
  }
}
.box-image-four-1 {
  grid-column: 3 / 4;
  grid-row: 1 / 3;
  @media(max-width: 860px){
    grid-column: 4 / 8;
    grid-row: 1;
    margin-bottom: 5px;
  }
} 
.box-image-four-2 {
  grid-column: 4 / 5;
  grid-row: 1 / 3;
  @media(max-width: 860px){
    grid-column: 4/ 8;
    grid-row: 2;
    margin-bottom: 0;
  }
} 
.box-image-four-3 {
  grid-column: 5 / 6;
  grid-row: 1 / 3;
  @media(max-width: 860px){
    display: none;
  }
} 
.avatar-preview-header-steps {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.grid-placeholder {
  opacity: 0.6;
}
.placeholder-cell {
  background-color: #e9e9e9;
  border-radius: 0.4em;
  display: flex;
  justify-content: center;
  align-items: center;
}
.button-see-more-images {
  position: absolute;
  right: 2em;
  z-index: 10;
  bottom: 2em;
}
</style>
